import { render } from "./Formato1996.vue?vue&type=template&id=5cbab756&scoped=true"
import script from "./Formato1996.vue?vue&type=script&lang=js"
export * from "./Formato1996.vue?vue&type=script&lang=js"

import "./Formato1996.vue?vue&type=style&index=0&id=5cbab756&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbab756"]])

export default __exports__